import React, { useState } from 'react'
import styled from 'styled-components'
import { ApolloProvider } from 'react-apollo'
import { client } from './apollo/client'
import { Route, BrowserRouter, Redirect } from 'react-router-dom'
import { useGlobalData, useGlobalChartData } from './contexts/GlobalData'

import OverviewPage from './pages/OverviewPage'
import TokenPage from './pages/TokenPage'
import PairPage from './pages/PairPage'

import { OVERVIEW_TOKEN_BLACKLIST, PAIR_BLACKLIST } from './constants'
import LocalLoader from './components/LocalLoader'
import { useLatestBlock } from './contexts/Application'
import { isAddress } from './utils'

const AppWrapper = styled.div`
  position: relative;
  width: 100%;
`
const ContentWrapper = styled.div`
  display: grid;

  @media screen and (max-width: 1400px) {
  }

  @media screen and (max-width: 1080px) {
    max-width: 100vw;
    overflow: hidden;
    grid-gap: 0;
  }
`

/**
 * Wrap the component with the header and sidebar pinned tab
 */
const LayoutWrapper = ({ children, savedOpen, setSavedOpen }) => {
  return (
    <>
      <ContentWrapper open={savedOpen}>{children}</ContentWrapper>
    </>
  )
}

function App() {
  const [savedOpen, setSavedOpen] = useState(false)

  const globalData = useGlobalData()
  const globalChartData = useGlobalChartData()
  const latestBlock = useLatestBlock()
  return (
    <ApolloProvider client={client}>
      <AppWrapper>
        {latestBlock &&
        globalData &&
        Object.keys(globalData).length > 0 &&
        globalChartData &&
        Object.keys(globalChartData).length > 0 ? (
          <BrowserRouter basename="/defi/swap-info">
            <Route path="/" exact>
              <LayoutWrapper savedOpen={savedOpen} setSavedOpen={setSavedOpen}>
                <OverviewPage />
              </LayoutWrapper>
            </Route>
            <Route
              exacts
              strict
              path="/token/:tokenAddress"
              render={({ match }) => {
                if (OVERVIEW_TOKEN_BLACKLIST.includes(match.params.tokenAddress.toLowerCase())) {
                  return <Redirect to="/" />
                }
                if (isAddress(match.params.tokenAddress.toLowerCase())) {
                  return (
                    <LayoutWrapper savedOpen={savedOpen} setSavedOpen={setSavedOpen}>
                      <TokenPage address={match.params.tokenAddress.toLowerCase()} />
                    </LayoutWrapper>
                  )
                } else {
                  return <Redirect to="/" />
                }
              }}
            />
            <Route
              exacts
              strict
              path="/pair/:pairAddress"
              render={({ match }) => {
                if (PAIR_BLACKLIST.includes(match.params.pairAddress.toLowerCase())) {
                  return <Redirect to="/home" />
                }
                if (isAddress(match.params.pairAddress.toLowerCase())) {
                  return (
                    <LayoutWrapper savedOpen={savedOpen} setSavedOpen={setSavedOpen}>
                      <PairPage pairAddress={match.params.pairAddress.toLowerCase()} />
                    </LayoutWrapper>
                  )
                } else {
                  return <Redirect to="/home" />
                }
              }}
            />
          </BrowserRouter>
        ) : (
          <LocalLoader fill="true" />
        )}
      </AppWrapper>
    </ApolloProvider>
  )
}

export default App
